import { NgClass, NgForOf, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Question } from '@models/dynamic-forms/question';

@Component({
  selector: 'app-radio-input',
  templateUrl: './radio-input.component.html',
  imports: [ReactiveFormsModule, NgForOf, NgClass, NgIf],
})
export class RadioInputComponent {
  @Input() public form: FormGroup;
  @Input() public question: Question;
}
